<template>
    <div style="width: 100%; height: 100%">
        <div v-if="parmas.series" class="charts" ref="charts" :parmas='parmas' style="width: 100%; height: 100%"></div>
        <dv-loading v-else>Loading...</dv-loading>
    </div>
</template>

<script>
// 3D 饼图
import Highcharts from 'highcharts/highstock';
export default {
    props: {
        parmas: {
            typeof: Object
        }
    },
    components: {

    },
    data() {
        return {
            chart: null
        };
    },
    computed: {

    },
    watch: {
        parmas:{
            deep:true, //开启监听模式
            handler() {
                this.initCharts();
            },
            immediate: true
        }
    },
    created() {

    },
    mounted() {
    },
    methods: {
        initCharts() {
            this.$nextTick(() => {
                if(this.$refs.charts) {  // 处理nextTick:Cannot read property 'nodeName' of undefined"
                    this.chart = Highcharts.chart(this.$refs.charts, this.parmas, this.parmas.callBack);
                    
                }
            })
        }
    },
};
</script>

<style scoped >

</style>
